import React, { useLayoutEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import "jquery/dist/jquery.min";
import "bootstrap/dist/js/bootstrap.min";

import { deleteAllCookies, getCookie } from "./utility/Cookie";

import Home from "./Pages/Home";
import Contact from "./Pages/contact";
import Register from "./Pages/Register";
import Login from "./Pages/Login";
import Header from "./Common/Header";

import Dashboard from "./Dashboard/Dashboard";
import Courses from "./Pages/Courses";
import LoginOld from "./Dashboard/LoginOld";
import Reading from "./Pages/Reading";
import ReadingInside from "./Pages/ReadingInside";
import MyProfile from "./MyProfile/MyProfile";
import CourseInside from "./CourseInside/CourseInside";
import PersonInfo from "./PersonInfo/PersonInfo";
import EditProfile from "./EditProfile/EditProfile";
import Settings from "./Pages/Settings";
import SettingsInfoEdit from "./Pages/layout/SettingsInfoEdit";
import MyCourses from "./Pages/MyCourses";
import NotFound from "./Pages/NotFound";
import Pricing from "./Pages/Pricing";
import QuizzesResults from "./Pages/QuizzesResults";
import Payment from "./Pages/Payment";
import PaymentState from "./Pages/PaymentState";
import Accomplishments from "./Pages/Accomplishments";
import About from "./Pages/About";
import { clear } from "@testing-library/user-event/dist/clear";



export const App = () => {
  const pathname = window.location.href;
  const [notIsDashboard, setNotIsDashboard] = useState(false);
  const TOKEN = getCookie("_t_");
  const [role, setRole] = useState("");


  const handleLogout = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((res) => {
        if (res.status === "success") {
        }
      });
    localStorage.removeItem("token");
    localStorage.removeItem("_g_user");
    deleteAllCookies();
    // window.location.href = "/";
  };

  const deleteAllCookies = () => {
    let cookies = document.cookie.split(";");
    console.log(cookies);
    for (let i = 0; i < cookies.length; i++) {

      let cookie = cookies[i];
      console.log(cookie);
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + `=;expires=Thu, 18 Dec 2013 12:00:00 UTC`;
    }
  };
  useLayoutEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/verify`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("_t_")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        if (data.status === "error") {
          localStorage.removeItem("token");
          localStorage.clear();
          deleteAllCookies();
          console.clear();
          if (pathname.includes("/dashboard")) {
            window.location.href = "/admin";
          }
        }
      });
    setRole(getCookie("_r_"));
  }, []);

  useLayoutEffect(() => {
    if (pathname.includes("/dashboard") || pathname.includes("/admin")) {
      return setNotIsDashboard(false);
    }
    setNotIsDashboard(true);
  }, [pathname]);

  return (
    <>
      <BrowserRouter>
        {notIsDashboard && <Header />}
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/courses" component={Courses} />
          <Route path="/pricing" component={Pricing} />
          <Route path="/reading" component={Reading} />
          <Route path="/reading-inside/:_id" component={ReadingInside} />
          <Route path="/course-inside/:_id" component={CourseInside} />
          <Route path="/person-info" component={PersonInfo} />
          <Route path="/contact" component={Contact} />
          <Route path="/about" component={About} />
          <Route path="/admin" component={LoginOld} />
          {TOKEN ? (
            <>
              {role === "Admin" && (
                <Route path="/dashboard" component={Dashboard} />
              )}
              <Route path="/my-courses" component={MyCourses} />
              <Route path="/my-profile" component={MyProfile} />
              <Route path="/edit-profile" component={EditProfile} />
              <Route path="/accomplishments" component={Accomplishments} />
              <Route path="/quizzes-results" component={QuizzesResults} />
              <Route path="/settings" component={Settings} />
              <Route path="/settings-info-edit" component={SettingsInfoEdit} />
              <Route path="/payment/:token" component={Payment} />
              <Route path="/payment-state" component={PaymentState} />
              {/* <Route path="/dashboard/*" component={NotFound} /> */}
            </>
          ) : (
            <>
              <Route path="/register" component={Register} />
              <Route path="/login" component={Login} />
              {/* <Route path="*" component={NotFound} /> */}
              {/* <Route path="/dashboard/*" component={NotFound} /> */}
            </>
          )}

          <Route path="*" component={NotFound} />
        </Switch>
      </BrowserRouter>
    </>
  );
};
